module.exports = __webpack_public_path__ + "da485f95e4820c2815db7a8281305d11.png";